import {
  initialState,
  Actions,
  State,
  MARK_ALL_NOTIFICATIONS_READ,
  MARK_ALL_NOTIFICATIONS_READ_SUCCESS,
  MARK_ALL_NOTIFICATIONS_READ_ERROR,
} from '../../types/in-app-notification/mark-all-as-read';

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case MARK_ALL_NOTIFICATIONS_READ:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case MARK_ALL_NOTIFICATIONS_READ_SUCCESS:
      return {
        ...state,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case MARK_ALL_NOTIFICATIONS_READ_ERROR:
      return {
        ...state,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    default:
      return state;
  }
};

export default reducers;
